import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CityInterface, IdInterface } from '../data';
import { CityProvider } from '../providers/city.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetCitiesUseCaseParams {
    countryId: IdInterface;
}

@Injectable()
export class GetCitiesUseCase implements UseCaseWithParam<GetCitiesUseCaseParams, Observable<Transaction<CityInterface[]>>> {
    constructor(private cityProvider: CityProvider) {}

    bind(params: GetCitiesUseCaseParams): Observable<Transaction<CityInterface[]>> {
        return this.cityProvider.find(params.countryId).pipe(
            map((transaction) =>
                transaction.map(
                    (cities) => Transaction.success(cloneDeep(cities)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
